import * as React from 'react';

const BlueContentMobileIllustrationSvg = (
    props: React.SVGProps<SVGSVGElement>,
) => (
    <svg viewBox="0 0 320 160" {...props}>
        <style>
            {
                '\n        .blue-content-mobile-illustration_svg__blue-content-mobile-illustration2{opacity:.5}.blue-content-mobile-illustration_svg__blue-content-mobile-illustration3{fill:#fff}.blue-content-mobile-illustration_svg__blue-content-mobile-illustration4{fill:#59c3a3}.blue-content-mobile-illustration_svg__blue-content-mobile-illustration5{fill:#ffa71a}.blue-content-mobile-illustration_svg__blue-content-mobile-illustration6{fill:#a43b1c}.blue-content-mobile-illustration_svg__blue-content-mobile-illustration8{fill:#479980}.blue-content-mobile-illustration_svg__blue-content-mobile-illustration9{fill:#227270}.blue-content-mobile-illustration_svg__blue-content-mobile-illustration10{fill:#f6682f}\n    '
            }
        </style>
        <path fill="#b7f1ef" d="M0 .4h320V160H0z" />
        <clipPath id="blue-content-mobile-illustration_svg__eds-illustration--blue-content-mobile--SVGID_2">
            <path
                className="blue-content-mobile-illustration_svg__eds-illustration--blue-content-mobile--SVGID_1"
                overflow="visible"
                d="M0 .4h320V160H0z"
            />
        </clipPath>
        <g clipPath="url(#blue-content-mobile-illustration_svg__eds-illustration--blue-content-mobile--SVGID_2)">
            <g className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration2">
                <path
                    className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration3"
                    d="M219.7-61.5h97.5c3.3 0 6 2.7 6 6v111c0 3.3-2.7 6-6 6h-97.5c-3.3 0-6-2.7-6-6v-111c0-3.3 2.7-6 6-6z"
                />
            </g>
            <g className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration2">
                <path
                    className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration3"
                    d="M34.8 103.4h78.4c3.3 0 6 2.7 6 6v62.8c0 3.3-2.7 6-6 6H34.8c-3.3 0-6-2.7-6-6v-62.8c0-3.3 2.6-6 6-6z"
                />
            </g>
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration4"
                d="M135.8 174.4c-10-7-63.9-103.9-61.6-124.6 3.4-30.5 33.6-14.1 51.2-10.4 24.2 5.1 32.2 4 71.5-10 18.9-6.7 61.9-13.1 45.2 41-6.6 21.5-27.1 63.8-36.9 86.9-11 26-57.2 25.7-69.4 17.1z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration3"
                d="M197.2 63.2c-5.2-3.5-20.5-5.7-20.5-5.7l-18.8-1.1S136 59.8 132 64.3c-5.1 5.6-9.2 15.2-12.8 32.8-4.7 22.2-2.3 16.4 12.9 44.3 1.6 2.9 60.5 13.9 74.2 8.2 0 0-1.4-4.5 1.7-8 15.1-.2-3.7-73.6-10.8-78.4z"
            />
            <path d="M187.8 45.3c-.1 0-.2 0-.4-.1-.9-.4-1.1-2-.3-3.9.7-1.9 2-3 2.9-2.7s1.1 2 .3 3.9c-.5 1.7-1.6 2.8-2.5 2.8zm0-3.8c-.6 1.6-.5 2.9-.1 3s1.4-.7 2-2.3.4-2.9.1-3-1.4.7-2 2.3z" />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration5"
                d="M176.7 57.5c-.7-1.9-.8-3.9-.3-5.8 0 0 5.6 2.2 6.8 1.1S186 47 186 47c.8 0 1.6-.1 2.4-.3-.8-1.6-.1-4.5-.1-4.5s3.4-8.4 3.5-9.8c.2-2.2-2.9-15.3-16.8-13.6-13.6 1.7-12.4 15.9-11.6 21-.3 5.9-2.2 11.7-5.6 16.5 0 0 3.9 7.4 10.4 7.8 4.6.3 8.7-2.5 8.5-6.6z"
            />
            <circle
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration6"
                cx={177.1}
                cy={10.8}
                r={4.8}
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration6"
                d="M170.1 38.2s-2.6-5.7.4-6.5c2.6-.6 3.7 2.6 3.6 4.2 1.8-1 3.1-2.7 3.6-4.7 1.9.9 10.2 4 14.8 4.3 2-5-2-18.4-17.5-16.6s-11.6 21-11.6 21L163 43l3.1-1.8 4-3z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration5"
                d="M182.2 33.4l2.6-5.8-1.1 6.9"
            />
            <path d="M184.7 44.1c-.1 0-.2 0-.4-.1-.9-.4-1.1-2-.3-3.9.3-.8.7-1.5 1.3-2.1.4-.5 1-.7 1.6-.6.9.4 1.1 2 .3 3.9-.6 1.7-1.6 2.8-2.5 2.8zm0-3.8c-.6 1.6-.4 2.9 0 3s1.4-.7 2-2.3.4-2.9.1-3c-.2-.1-.5.1-.9.4-.6.6-.9 1.2-1.2 1.9z" />
            <path d="M176.215 37.129l.255-.652 8.01 3.13-.255.652z" />
            <path
                d="M157.9 56.3l-1.4.3c2.2 8.6 9.5 14.1 9.5 14.1l5-6.2 7.1 3.8-1.4-10.8c.2 3-2.6 5.9-5.7 6.4-4 .6-9.4-1.3-13.1-7.6z"
                fill="#fbe986"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration4"
                d="M134.5 150.6c-6.8-85.7-2.5-130.3-28-129.9-13.7.2-34 13.6-39.3 37s41.3 96.9 56.4 113.2c13.5 14.5 76.2 20.6 81.9-13.4-6.8 17.5-68.6 23.8-71-6.9z"
            />
            <g className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration2">
                <path
                    className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration3"
                    d="M134.3 150.4c-6.8-85.7-2.5-130.3-28-129.9-13.7.2-34 13.6-39.3 37s41.2 96.9 56.3 113.2c13.4 14.5 76.2 20.6 81.9-13.4-6.7 17.5-68.4 23.8-70.9-6.9z"
                />
            </g>
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M124.1 134c0 5.8 4.1 10.8 9.8 11.9l-.3-3.9c-4.4-1.4-6.9-6.2-5.4-10.7.7-2.2 2.3-4 4.3-5-.1-1.3-.2-2.6-.2-3.9-4.9 1.8-8.2 6.4-8.2 11.6z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M119.7 134c0 8.4 6.3 15.4 14.6 16.4-.1-1.3-.2-2.5-.3-3.8-7-1.3-11.6-8-10.3-14.9.8-4.6 4.2-8.4 8.6-9.9-.1-1.3-.2-2.5-.2-3.8-7.3 1.9-12.4 8.5-12.4 16z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M128.5 134c0 3.3 2 6.2 5.1 7.3l-.3-4.5c-1.3-1.4-1.4-3.5-.4-5.1l-.3-4.5a7.64 7.64 0 00-4.1 6.8z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M133.2 135.4c-.1-.8-.1-1.6-.2-2.4-.1.3-.1.7-.1 1 0 .5.1.9.3 1.4zM119.7 60.6c0 6.5 3.8 12.4 9.7 15.1-.1-1.5-.2-3-.3-4.4-5.9-3.9-7.5-11.9-3.6-17.8.4-.7.9-1.3 1.5-1.8-.2-1.5-.4-2.9-.7-4.3-4.1 3.1-6.6 8-6.6 13.2z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M129.1 70.4c-.2-2.2-.4-4.3-.6-6.4-.7-1.6-.9-3.4-.5-5.2-.2-2.2-.5-4.3-.8-6.3-4.5 5-4 12.7 1 17.2.2.2.5.5.9.7zM106.6 134c0 16.4 13.3 29.7 29.7 29.7 1.4 0 2.7-.1 4.1-.3-1.1-1-2.1-2.2-2.9-3.4h-1.2c-14.4-.1-25.9-11.8-25.8-26.2.1-12.4 8.9-23 21-25.4-.1-1.2-.1-2.5-.2-3.7-14.3 2.5-24.7 14.8-24.7 29.3z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M111 134c0 14 11.3 25.3 25.3 25.3h.7c-.7-1.2-1.3-2.4-1.7-3.7-11.9-.5-21.2-10.6-20.6-22.6.4-9.8 7.4-18.1 17-20.1-.1-1.2-.1-2.5-.2-3.7-11.9 2.3-20.5 12.7-20.5 24.8z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M115.3 134c0 11.1 8.7 20.2 19.7 20.9-.4-1.2-.6-2.5-.7-3.8-9.5-1-16.3-9.5-15.3-19 .8-7.2 5.9-13.1 12.9-14.9-.1-1.3-.1-2.5-.2-3.7-9.5 2.2-16.3 10.7-16.4 20.5zM205 158.8c.1-.4.2-.8.2-1.2-.2.4-.3.8-.5 1.1l.3.1zM203.7 163c.5-1.2.8-2.3 1.1-3.6l-.5-.2c-.7 1.1-1.6 2.1-2.6 3 .8.2 1.4.5 2 .8z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M145.1 166.9c-1.5-.8-2.8-1.8-4.1-2.9-16.6 2.7-32.2-8.5-34.9-25.1-2.7-16.6 8.5-32.2 25.1-34.9-.1-1.2-.1-2.5-.2-3.7-18.6 2.9-31.3 20.3-28.4 38.8.2 1.6.6 3.2 1.1 4.7 4.1 6.4 8 12.1 11.5 16.9 8.4 6.6 19.5 8.9 29.9 6.2zM93.6 24.3c0 11.9-9.7 21.6-21.6 21.6h-.7c-.6 1.2-1.2 2.4-1.7 3.6.8.1 1.6.1 2.4.1 14 0 25.3-11.3 25.3-25.3 0-.6 0-1.2-.1-1.8-1.2.4-2.4.9-3.6 1.5v.3z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M98 24.3c0 14.4-11.7 26-26 26-.9 0-1.8 0-2.6-.1-.5 1.2-.9 2.3-1.3 3.6 16.2 2.2 31.2-9.3 33.3-25.5.2-1.3.3-2.6.3-3.9 0-1 0-2-.2-3-1.2.3-2.4.6-3.6 1 .1.5.1 1.2.1 1.9zM97.3 97.7c0-14-11.4-25.3-25.3-25.3-1.3 0-2.5.1-3.8.3.3 1.2.6 2.4 1 3.6.9-.1 1.8-.2 2.8-.2 11.9 0 21.6 9.7 21.6 21.6 0 6.3-2.8 12.3-7.6 16.4l1.8 3.3c6-4.8 9.5-12.1 9.5-19.7z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M106.1 97.7c.1-18.8-15.1-34-33.9-34.1-1.8 0-3.7.1-5.5.4.1 1.2.2 2.4.5 3.7 1.6-.2 3.2-.4 4.8-.4 16.8 0 30.4 13.6 30.4 30.3 0 9.5-4.5 18.5-12 24.2.6 1.1 1.2 2.2 1.8 3.2 8.7-6.3 13.9-16.5 13.9-27.3z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M101.7 97.7C101.7 81.3 88.4 68 72 68c-1.6 0-3.2.1-4.7.4.2 1.2.5 2.4.8 3.6 1.3-.2 2.6-.3 3.9-.3 14.4 0 26 11.7 26 26 0 7.9-3.6 15.3-9.8 20.3l1.8 3.3c7.4-5.6 11.7-14.4 11.7-23.6zM73.9 41.4c-.8 1.2-1.5 2.5-2.2 3.8h.3c11.6 0 21-9.3 21-20.9-1.3.6-2.6 1.3-3.8 2.1-1 8-7.4 14.2-15.3 15z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M88.4 26.9c-1.9 1.2-3.6 2.5-5.3 4-1.1 1.9-2.7 3.4-4.6 4.5-1.5 1.7-2.9 3.4-4.1 5.3 7.1-1.1 12.8-6.6 14-13.8zM115.3 60.6c0 9.1 5.8 17.1 14.4 19.9-.1-1.4-.2-2.7-.3-4-8.7-3.7-12.8-13.8-9.1-22.6 1.2-2.9 3.3-5.4 5.8-7.3-.2-1.4-.5-2.7-.8-3.9-6.1 3.8-9.9 10.6-10 17.9zM102.4 24.3c0 16.8-13.6 30.4-30.4 30.4-1.4 0-2.8-.1-4.1-.3-.3 1.1-.6 2.2-.8 3.3 0 .1-.1.2-.1.3 1.7.3 3.4.4 5.1.4 18.8 0 34-15.2 34.1-34 0-1.2-.1-2.4-.2-3.6-1.2.1-2.5.2-3.7.4 0 1 .1 2.1.1 3.1zM93 97.7c0-11.6-9.4-20.9-21-20.9-.9 0-1.7 0-2.6.2l1.2 3.6c.4 0 .9-.1 1.4-.1 9.5 0 17.2 7.7 17.2 17.2 0 4.7-1.9 9.2-5.3 12.5l1.8 3.4c4.6-4.1 7.3-9.8 7.3-15.9z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M102.2 60.6c0 16.6 12 30.8 28.4 33.6-.1-1.3-.1-2.5-.2-3.8-16.5-3.2-27.2-19.2-23.9-35.7 1.8-9.3 7.8-17.1 16.3-21.3-.4-1.1-1-2.3-1.5-3.4-11.7 5.8-19.1 17.6-19.1 30.6z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M111 60.6c0 11.6 7.9 21.7 19.1 24.5-.1-1.3-.2-2.6-.2-3.9-11.4-3.6-17.7-15.7-14.2-27.1 1.6-5.1 5-9.5 9.6-12.2-.3-1.3-.6-2.5-.9-3.7-8.3 4.5-13.4 13.1-13.4 22.4z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M106.6 60.6c0 14.1 9.9 26.3 23.8 29.1-.1-1.3-.1-2.6-.2-3.8-14-3.4-22.5-17.5-19.1-31.4 1.8-7.2 6.5-13.4 13.1-16.8-.4-1.2-.8-2.4-1.2-3.5-10.1 4.9-16.4 15.2-16.4 26.4zM74.4 90.3c1.4 3.4 3 6.9 4.8 10.4.4-.9.6-2 .6-3 0-3.4-2.1-6.4-5.4-7.4z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M106.8 24.3C106.7 43.5 91.2 59 72 59c-1.7 0-3.5-.1-5.2-.4-.2 1.5-.3 3.1-.2 4.7 19-3 36.7 10 39.7 29 2 12.8-3.3 25.7-13.8 33.4 3.3 5.6 6.6 11.1 9.9 16.3-4.4-18.7 7.2-37.4 25.9-41.8.9-.2 1.7-.4 2.6-.5-.1-1.6-.2-3.2-.3-4.7-18.9-3.1-31.8-21-28.7-39.9 1.8-11.1 8.8-20.6 18.9-25.5-3.3-5.8-7.8-8.8-14.3-8.7.2 1 .3 2.2.3 3.4z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M72.5 85.5c.5 1.3 1 2.6 1.6 3.9 4.5 1.2 7.3 5.8 6.1 10.3-.1.6-.4 1.2-.6 1.7.6 1.3 1.2 2.5 1.9 3.8 4.2-5.2 3.4-12.9-1.8-17.1-2.1-1.6-4.6-2.5-7.2-2.6z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration8"
                d="M72 81.1h-1.1c.4 1.2.9 2.4 1.3 3.7 7.1.1 12.8 5.9 12.7 13 0 3-1.1 6-3.1 8.3.6 1.2 1.2 2.3 1.8 3.5 6.5-6.4 6.7-16.8.3-23.4-3.1-3.3-7.4-5.1-11.9-5.1z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration9"
                d="M145.1 166.9c27.1 16.2 56.7-4.3 56.7-4.3l42 50.5 7.4-4.4s-22.7-47.2-33.4-66.7c-4.4-8.1-62.1-10.2-84.6-5.2.8 8.2-.9 22.4 11.9 30.1z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration9"
                d="M190.3 234.3s-3.5-50.2-2.9-72.9c.5-17.1 27.6-21.1 24.5 3.2-3.9 30.4-11.1 70.3-11.1 70.3l-10.5-.6z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration10"
                d="M189.8 140.2l-30.6-5.3c-.6 0-1-.5-.9-1.1s.5-1 1.1-.9l39.2-.6h.2l31.5 6.3"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration5"
                d="M173 127.7s5.5 5.2 7.7 6.4 8.9 3.1 8.9 3.1c.5-1.1.9-2.2 1.1-3.4-.1-2-2.9-5-4.4-6.3s-7.3-3.6-7.3-3.6l-10.3-3.9s-5.3 1.4-4.8 6.3c3 .8 6 1.3 9.1 1.4z"
            />
            <path
                className="blue-content-mobile-illustration_svg__blue-content-mobile-illustration10"
                d="M229.7 138.6l-38.3 1.5c-.6 0-1-.4-1.1-.9 0-.2 0-.3.1-.5l15.5-36.6c.2-.4.6-.6 1-.6L244 103c.6 0 1 .5 1 1 0 .1 0 .2-.1.3L230.6 138c-.2.4-.5.6-.9.6z"
            />
            <path d="M184.3 48.5c-.9 0-1.7-.6-2-1.5l.4-.1c.2.7.9 1.2 1.6 1.2v.4z" />
        </g>
    </svg>
);

BlueContentMobileIllustrationSvg.displayName =
    'BlueContentMobileIllustrationSvg';
export default BlueContentMobileIllustrationSvg;
